import moment from "moment";

import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { InboundFaxNotes } from "@/Documents/Models/InboundFax/InboundFaxNotes";

interface InboundFaxNoteListProp {
    faxNotes: InboundFaxNotes[];
}

function InboundFaxNoteList(props: InboundFaxNoteListProp): JSX.Element {
    const content = props.faxNotes == null || props.faxNotes.length === 0
        ? renderEmpty()
        : renderWithNotes(props.faxNotes);

    return content;
}

function renderEmpty(): JSX.Element {
    return (
        <div className="notes-dropdown-content" />
    );
}

function renderWithNotes(faxNotes: InboundFaxNotes[]): JSX.Element {
    const notesRenderList = faxNotes.map(item => renderNoteLine(item));

    return (
        <div className="notes-dropdown-content">
            <div className="scroll-limit">
                {notesRenderList}
            </div>
        </div>
    );
}

function renderNoteLine(note: InboundFaxNotes): JSX.Element {
    const employee = cacheStore.GetEmployeeByContactFacetId(note.CreatedByEmployeeId);
    const formattedDate = moment(note.CreatedDate).format("YYYY/MM/DD HH:mm:ss");

    return (
        <div key={note.Id} className="notes-collection-item">
            <div className="memo-header">
                <strong>{nameWithPrefix(employee)}</strong> <span>{formattedDate}</span>
            </div>
            <div className="note-container">
                {JSXHelper.BreakStringIntoParagraphs(note.Notes)}
            </div>
        </div>
    );
}

function nameWithPrefix(employee: Employee): string {
    const prefix = cacheStore.GetLocalizedValueByLookupId(employee?.PrefixLookupId);
    const name = [employee?.LastName, employee?.FirstName].filter(Boolean).join(", ");
    return prefix ? `${prefix} ${name}` : `${name}`;
}

export { InboundFaxNoteList };
